import { Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type {
  IApiBuildResponseBody,
  IApiPipelineResponseBody,
} from '~/lib/api/modules/Builds';
import { Table } from '~/components/molecules/Table';
import { PipelineError } from './PipelineError';
import { PipelineStatus } from './PipelineStatus';
import { PipelineStepper } from './PipelineStepper';

const LAST_ERROR_MAX_LINES = 1;

export type IPipelineListItemProps = {
  build: IApiBuildResponseBody;
  pipeline: IApiPipelineResponseBody;
};

const styles = stylex.create({
  body$status: { alignSelf: 'flex-start' },
  stepperContainer: {
    alignSelf: 'stretch',
  },
  pipelineContainer: {
    paddingLeft: '0.5rem',
  },
});

export const PipelineListItem: React.FC<IPipelineListItemProps> = (props) => {
  const { build, pipeline } = props;

  return (
    <Table.Row>
      <Table.Body sx={styles.body$status}>
        <PipelineStatus pipeline={pipeline} />
      </Table.Body>
      <Stack as={Table.Body} gap={1}>
        <div {...stylex.props(styles.stepperContainer)}>
          <PipelineStepper build={build} pipeline={pipeline} />
        </div>

        {pipeline.current.error ? (
          <div {...stylex.props(styles.pipelineContainer)}>
            <PipelineError
              pipeline={pipeline}
              maxLines={LAST_ERROR_MAX_LINES}
            />
          </div>
        ) : null}
      </Stack>
    </Table.Row>
  );
};
